import CustomTable from "components/shared/table";
import { generatePath, useHistory } from "react-router-dom";
import { columnsAdmin, useColumns } from "./columns";
import { ApiKey } from "data/models";

export interface ApiKeyRow {
  id: string;
  products: ApiKey["products"];
  createdDate: number;
  expireDate: number;
  name: string;
  status: string;
  consumerKey: string;
}

const keysToRows = (keys: ApiKey[]): ApiKeyRow[] => {
  const keys_ = keys.map((key) => {
    return {
      id: key.name,
      products: key.products,
      createdDate: key.createdDate,
      expireDate: key.expireDate,
      name: key.displayName ? key.displayName : key.name,
      status: key.status,
      consumerKey: key.consumerKey,
    };
  });
  return keys_.sort((a, b) => {
    const nameA = a.name.toUpperCase();
    const nameB = b.name.toUpperCase();
    if (nameA < nameB) return -1;
    if (nameA > nameB) return 1;
    return 0;
  });
};

interface ApiKeyTableProps {
  data: ApiKey[];
  isLoading: boolean;
  apiKeyDetailsRoute: string;
  accountName?: string;
  accountId?: string;
  handleClick?: (row: ApiKeyRow) => void;
  identityId?: string;
}

export const ApiKeyTable = (props: ApiKeyTableProps) => {
  const history = useHistory();

  const defaultHandleOnRowClick = (row: ApiKeyRow) => {
    history.push(
      generatePath(props.apiKeyDetailsRoute, {
        accountId: props.accountId,
        keyName: row.id,
      }),
      {
        accountId: props.accountId,
        accountName: props.accountName,
        keyName: row.id,
      }
    );
  };

  return (
    <CustomTable
      rows={props.data ? keysToRows(props.data) : []}
      columns={
        props.accountName
          ? columnsAdmin
          : useColumns(props.identityId ? props.identityId : "")
      }
      onRowClick={props.handleClick ?? defaultHandleOnRowClick}
      isLoading={props.isLoading}
      overlayText={"You do not have any API Keys."}
    />
  );
};
